import { createFileRoute } from '@tanstack/react-router'
import EditionPublish from 'Edition/components/sections/Publish/EditionPublish'

export const Route = createFileRoute('/work/$workId_/edition/$editionId/publish')({
    component: EditionPublish,
})
